import styled from '@emotion/styled';
import { Button, Typography } from '@mgmresorts/mgm-ui';

export const StyledContent = styled.div``;

export const PasswordValidationHint = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 5px;
  &:last-child {
    margin-bottom: 16px;
  }
`;

export const StyledPasswordHint = styled(Typography)`
  color: ${({ theme }) => theme.semantic.FgDefault};
  column-gap: ${({ theme }) => theme.semantic.SpaceComponentS}px;
  margin-bottom: ${({ theme }) => theme.semantic.SpaceComponentXs}px;
  display: flex;
  align-items: center;

  &.hint-success {
    color: ${({ theme }) => theme.semantic.SuccessDefault};

    path {
      fill: ${({ theme }) => theme.semantic.SuccessDefault};
    }
  }

  &.hint-error {
    color: ${({ theme }) => theme.semantic.ErrorDefault};

    path {
      fill: ${({ theme }) => theme.semantic.ErrorDefault};
    }
  }

  &:last-child {
    margin-bottom: 0;
  }
`;

export const Centered = styled.div`
  margin: auto;
`;

export const StyledLink = styled(Button)`
  margin-top: ${({ theme }) => theme.semantic.SpaceComponentL}px;
`;

export const StyledHeading = styled(Typography)`
  color: ${({ theme }) => theme.semantic.FgDefault};
  padding-top: ${({ theme }) => theme.semantic.SpaceComponentL}px;
  margin-top: ${({ theme }) => theme.semantic.SpaceComponentXl}px;
  margin-bottom: ${({ theme }) => theme.semantic.SpaceComponentL}px;
  @media (max-width: 768px) {
    font-size: ${({ theme }) => theme.semantic.HeadingMedium2.fontSize}px;
  }
`;

export const StyledAlertContainer = styled.div`
  margin-bottom: ${({ theme }) => theme.semantic.SpaceComponentL}px;
`;

export const StyledNewPasswordContainer = styled.div`
  margin-top: ${({ theme }) => theme.semantic.SpaceComponentL}px;
  margin-bottom: ${({ theme }) => theme.semantic.SpaceComponentM}px;
`;
export const StyledConfirmPasswordContainer = styled.div`
  margin-bottom: ${({ theme }) => theme.semantic.SpaceComponentM}px;
`;
export const StyledPasswordHintList = styled.ul`
  margin: ${({ theme }) => theme.semantic.SpaceComponentNone}px;
  padding-left: ${({ theme }) => theme.semantic.BorderWidthFocused}rem;
  list-style-type: disc;
  list-style-position: outside;
`;

export const StyledPasswordHintItem = styled.li`
  margin-bottom: ${({ theme }) => theme.semantic.BorderWidthSubtle}rem;
  color: ${({ theme }) => theme.semantic.FgDefault};
`;

export const StyledPasswordHintText = styled(StyledPasswordHint)`
  display: inline;
`;
